export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[700px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500">有任何建议、意见或合作意向，欢迎通过以下方式与我们联系。</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-12">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="p-5">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">feedback@xiaocaomv.com</p>
            </div>
            <div className="p-5">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-700 mb-3">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@xiaocaomv.com</p>
            </div>
            <div className="p-5">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 mb-3">
                <i className="ri-bug-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">问题报告</h3>
              <p className="text-xs text-foreground-500">support@xiaocaomv.com</p>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-background-200/60 text-center">
            <p className="text-sm text-foreground-600 mb-5">我们也欢迎你通过以下社交媒体关注小草影院的最新动态</p>
            <div className="flex items-center justify-center gap-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-music-2-line text-lg"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}